"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var Track =
/** @class */
function () {
  function Track(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - trackId
   * @return Promise|Observable|any
   */


  Track.prototype.GetTrack = function (trackId) {
    return this.restClient.get('Track/UseCase/GetTrack', {
      trackId: trackId
    });
  };
  /**
   * @param string - eventId
   * @param string[]? - withData SessionTracks|TicketTypeTracks
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @param string? - query
   * @return Promise|Observable|any
   */


  Track.prototype.ListTracksForEvent = function (eventId, withData, sortBy, sortDirection, page, itemsPerPage, query) {
    if (withData === void 0) {
      withData = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (query === void 0) {
      query = null;
    }

    return this.restClient.get('Track/UseCase/ListTracksForEvent', {
      eventId: eventId,
      withData: withData,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage,
      query: query
    });
  }; // Commands

  /**
   * @param string - ticketTypeId
   * @param string - trackId
   * @return Promise|Observable|any
   */


  Track.prototype.AddTicketTypeToTrack = function (ticketTypeId, trackId) {
    return this.restClient.post('Track/UseCase/AddTicketTypeToTrack', {
      ticketTypeId: ticketTypeId,
      trackId: trackId
    });
  };
  /**
   * @param string - eventId
   * @param string - name
   * @param string? - description
   * @param string? - trackId
   * @return Promise|Observable|any
   */


  Track.prototype.CreateTrack = function (eventId, name, description, trackId) {
    if (description === void 0) {
      description = null;
    }

    if (trackId === void 0) {
      trackId = null;
    }

    return this.restClient.post('Track/UseCase/CreateTrack', {
      eventId: eventId,
      name: name,
      description: description,
      trackId: trackId
    });
  };
  /**
   * @param string - trackId
   * @return Promise|Observable|any
   */


  Track.prototype.DeleteTrack = function (trackId) {
    return this.restClient.post('Track/UseCase/DeleteTrack', {
      trackId: trackId
    });
  };
  /**
   * @param string - ticketTypeId
   * @param string - trackId
   * @return Promise|Observable|any
   */


  Track.prototype.RemoveTicketTypeFromTrack = function (ticketTypeId, trackId) {
    return this.restClient.post('Track/UseCase/RemoveTicketTypeFromTrack', {
      ticketTypeId: ticketTypeId,
      trackId: trackId
    });
  };
  /**
   * @param string - trackId
   * @return Promise|Observable|any
   */


  Track.prototype.RemoveTrack = function (trackId) {
    return this.restClient.post('Track/UseCase/RemoveTrack', {
      trackId: trackId
    });
  };
  /**
   * @param string - trackId
   * @param any[] - eventIds
   * @return Promise|Observable|any
   */


  Track.prototype.SetSessionsForTrack = function (trackId, eventIds) {
    return this.restClient.post('Track/UseCase/SetSessionsForTrack', {
      trackId: trackId,
      eventIds: eventIds
    });
  };
  /**
   * @param string - trackId
   * @param any[] - ticketTypeIds
   * @return Promise|Observable|any
   */


  Track.prototype.SetTicketTypesForTrack = function (trackId, ticketTypeIds) {
    return this.restClient.post('Track/UseCase/SetTicketTypesForTrack', {
      trackId: trackId,
      ticketTypeIds: ticketTypeIds
    });
  };
  /**
   * @param string - trackId
   * @param string - trackDescription
   * @return Promise|Observable|any
   */


  Track.prototype.SetTrackDescription = function (trackId, trackDescription) {
    return this.restClient.post('Track/UseCase/SetTrackDescription', {
      trackId: trackId,
      trackDescription: trackDescription
    });
  };
  /**
   * @param string - trackId
   * @param string - trackName
   * @return Promise|Observable|any
   */


  Track.prototype.SetTrackName = function (trackId, trackName) {
    return this.restClient.post('Track/UseCase/SetTrackName', {
      trackId: trackId,
      trackName: trackName
    });
  };
  /**
   * @param string - trackId
   * @param string? - name
   * @param string? - description
   * @return Promise|Observable|any
   */


  Track.prototype.UpdateTrack = function (trackId, name, description) {
    if (name === void 0) {
      name = null;
    }

    if (description === void 0) {
      description = null;
    }

    return this.restClient.post('Track/UseCase/UpdateTrack', {
      trackId: trackId,
      name: name,
      description: description
    });
  };

  return Track;
}();

exports.Track = Track;